import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiSlack,
  SiMacos,
  SiGithub,
  SiJupyter,
  SiMicrosoftteams,
  SiCanva,
  SiJirasoftware,
  SiDocker,
  SiGitlab,
  SiTableau,
} from "react-icons/si";
import { FaRobot } from "react-icons/fa";
import { FaLinux} from "react-icons/fa";
function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* Operating Systems */}
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <FaLinux />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>Linux</span>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiMacos />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>macOS</span>
        </div>
      </Col>

      {/* Code Editors */}
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiVisualstudiocode />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>VS Code</span>
        </div>
      </Col>

      {/* Version Control */}
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiGithub />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>GitHub</span>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiGitlab />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>GitLab</span>
        </div>
      </Col>

      {/* Development Tools */}
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiJupyter />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>Jupyter Notebook</span>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiDocker />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>Docker</span>
        </div>
      </Col>

      {/* Project Management */}
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiJirasoftware />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>Jira</span>
        </div>
      </Col>

      {/* Communication & Collaboration */}
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiSlack />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>Slack</span>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiMicrosoftteams />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>Microsoft Teams</span>
        </div>
      </Col>

      {/* Design & Visualization */}
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiCanva />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>Canva</span>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <SiTableau />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>Tableau</span>
        </div>
      </Col>

      {/* AI Assistant */}
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <FaRobot />
          <span style={{ fontSize: "0.8rem", marginTop: "5px" }}>GitHub Copilot</span>
        </div>
      </Col>
    </Row>
  );
}

export default Toolstack;
